import React, { useEffect } from 'react';
import './App.css';
import Routes from './Routes';
import history from './history';
import CustomRouter from './CustomRouter';
import { initialGoogleAnalytics } from './helpers/ga-helpers';
import { setLocalStorage } from './utils';
import { APP_SOURCE, APP_SOURCE_TYPES } from './data/local-storage-constants';
import { firebaseSetup, serviceWorkerSetup } from "./helpers/notification-helpers";

const App = (): JSX.Element => {
  useEffect(() => {
    // Register the service worker
    serviceWorkerSetup();
  }, []);

  initialGoogleAnalytics();

  // Initialize Firebase and Messaging
  firebaseSetup();


  return (
    <div>
      <CustomRouter history={history}>
        <Routes />
      </CustomRouter>
    </div>
  );
}

export default App;
